import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getUserId } from "../../../adblock-betafish/id/background/index";
import { License } from "../../../adblock-betafish/picreplacement/check";
import { Prefs } from "../../../adblock-betafish/alias/prefs";
export async function getInjectionInfo() {
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    const [isPremium, id, experimentFlags] = await Promise.all([
        License.isActiveLicense(),
        getUserId(),
        ewe.experiments.getFlags(),
    ]);
    const version = info.addonVersion;
    const blockCount = Prefs.get("blocked_total");
    return { isPremium, version, id, blockCount, experimentFlags };
}
